module.exports = __webpack_public_path__ + "img/errorinternalserver.329084b.webp";